<template>
	<el-dialog
    style="z-index:2022 !important;"
    :visible.sync="visibility"
    :modal-append-to-body="false"
    :show-close='false'
    class="xero-choose"
    :close-on-click-modal='false'
    width="840px"
    center
    >
        <div v-if="defaultData && defaultData.length > 0">
            <!-- <h1>We found the following tracking categories in<br />
            Xero, If you only want to look at certain<br />
            categories, tick them below. If you want to look at all<br />
            categories, press No.</h1> -->

            <el-alert v-if="isError" class="alert-message" :title="errorMessage" type="error" effect="dark" show-icon @close="closeAlert"/>

            <h1>
                We found the following tracking categories in Xero,<br>
                press continue to include all.
            </h1>
            <!-- <div class="tree-scroll">
                <el-tree
                ref="tree"
                :data="defaultData"
                show-checkbox
                :default-expanded-keys="defaultExpanded"
                :default-checked-keys="defaultExpanded"
                node-key="id"
                :empty-text="' '"
                @check-change="clickEvent">
                </el-tree>
            </div> -->

            <div class="category-list-container">
                <el-checkbox-group v-model="checkedData" class="peiso-checkbox" @change="getChecked">
                    <div v-for="(item, i) in defaultData" :key="`${i}`">
                        <el-checkbox v-for="(category, i) in item.children" class="m-bottom-5" :key="`checkbox-${category.id}`" :label="category, item">{{ `${category.label} (${item.label})` }}</el-checkbox>
                    </div>
                </el-checkbox-group>
            </div>
            <div class="btn">
                
                <!-- <el-button class="cancel" @click="operateYes">No</el-button> -->
                <!-- <el-button class="confirm" :disabled='chosed.length === 0' @click="getIds">Yes</el-button> -->
                <el-button class="confirm" @click="continueProcess">Continue</el-button>
            </div>
        </div>
        <div v-else>
            <h1>No tracking category has been set for this account Continue</h1>
            <div class="btn"><el-button class="confirm" @click="operateContinue">Continue</el-button></div>
        </div>

    </el-dialog>
</template>

<script>
import api from '../../api/xero'

export default {
    props: {
        visibility: {
            type: Boolean,
            default: false
        },
        getDataDoney: {
            type: Boolean,
            default: false
        },
        defaultExpanded: {
            type: Array,
            default: []
        },
        defaultData: {
            type: Array,
            default: []
        }
    },
    data () {
        return {
            chosed: [],
            errorMessage: '',
            isError: false,
            checkedData: [],
            selectedCategories: [],
        }
    },
    watch: {
        'defaultData': {
            deep: true,
            handler: function(val) {
                if (val.length) {
                    this.checkAllDataAvailable(val)
                }
            }
        }
    },
    methods: {
        closeAlert() {
            this.isError = false
        },
        clickEvent () {
            this.chosed = this.$refs.tree.getCheckedNodes()
        },

        getIds () {
            var that = this
            // const node_selected = this.$refs.tree.getCheckedNodes()
            // let format_selected = []
            // node_selected.forEach(item => {
            //     if (item.children) {
            //         format_selected.push({
            //             trackingCategoryID: item.id,
            //             name: item.label,
            //             options: []
            //         })
            //     } else {
            //         let hasParent = false
            //         format_selected.forEach(i => {
            //             if (i.trackingCategoryID == item.parent) {
            //                 hasParent = true
            //                 i.options.push({
            //                     trackingOptionID: item.id,
            //                     name: item.label
            //                 })
            //             }
            //         })
            //         if (!hasParent) {
            //             format_selected.push({
            //                 trackingCategoryID: item.parent,
            //                 name: item.label,
            //                 options: [{trackingOptionID: item.id, name: item.label}]
            //             })
            //         }
            //     }
            // })

            api.saveTrackingCategories({
                params: {categoryList: this.selectedCategories},
                callback: (res) => {
                    if (res.data.code == 0) {
                        that.$emit('close')
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        operateYes() {
            api.saveTrackingCategories({
                params: {categoryList: []},
                callback: (res) => {
                    if (res.data.code == 0) {
                        this.$emit('close')
                    } else {
                        Utils.alert('', res.data.message ,'error')
                    }
                }
            })
        },
        operateContinue() {
            this.$emit('close')
        },
        continueProcess() {
            if (!this.selectedCategories.length) {
                this.isError = true
                this.errorMessage = 'Plaese select a category'
                return
            } else {
                this.isError = false
                this.errorMessage = ''
                this.getIds()
            }
        },
        getChecked(checked) {
            var categories = this.defaultData.map((n) => {
                var category = {}
                category.trackingCategoryID = n.id
                category.name = n.label
                var selectedOptions = checked.filter((y) => category.trackingCategoryID == y.parent)
                selectedOptions = selectedOptions.map((selected) => {
                    var data = {
                        trackingOptionID: selected.id,
                        name: selected.label
                    }
                    return data
                })

                category.options = selectedOptions

                return category
            })

            var selectedCategory = categories.filter((cat) => cat.options.length)

            this.selectedCategories = selectedCategory
        },

        checkAllDataAvailable(data) {
            var checked = []
            data.forEach((n) => {
                n.children.forEach((y) => {
                    checked.push(y)
                })

            })

            console.log(checked)

            this.checkedData = checked
            this.getChecked(checked)
        }

    },
    beforeDestroy() {
        this.chosed = []
    },
    created() {
        
    }
}
</script>

<style lang="scss">
@import 'static/scss/scrollbar.scss';
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';
.tree-scroll{
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 30px;

}
.alert-message {
    margin-bottom: 2rem;
}

.category-list-container {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
    max-height: 450px;
    min-height: 250px;
    overflow: auto;

    &::-webkit-scrollbar {
		@extend .scrollbar;
	}

	&::-webkit-scrollbar-track {
		@extend .scrollbar-track;
	}

	&::-webkit-scrollbar-thumb {
		@extend .scrollbar-thumb;
	}

	&::-webkit-scrollbar-corner {
		@extend .scrollbar-corner;
	}

}

.xero-choose {
    .el-checkbox__input {
        > .el-checkbox__inner {
            width: 25px !important;
            height: 25px !important;
        }

        &.is-checked {
            > .el-checkbox__inner {
                background-color: var(--text-color) !important;
            }
        }
    }
    
}

</style>


// WEBPACK FOOTER //
// src/components/common/xerobindpop.vue